<div class="header-container">
  <div class="safe-area"></div>
  @if (!showGameScore() && !showGameReplay() && showNavbar()) {
    <div class="navbar">
      <ng-container [ngTemplateOutlet]="navbarTemplate()" />
    </div>
  }
  @if (showGameScore()) {
    <div class="game-score">
      <app-game-score
        [gameId]="gameId()"
        [gameName]="gameScoreName()"
        [isLocal]="isLocal()"
        [gameInterfaceState]="displayGameInterfaceState()"
        [score]="score()"
        [reward]="reward()"
        [countdown]="countdown()"
        [match]="match()"
        [soloTarget]="soloTarget()"
        [soloPrize]="soloPrize()"
        (backClickedEvent)="onBackClicked()"
        (closeClickedEvent)="onCloseClicked()"
        (cheatSheetClickedEvent)="onCheatSheetClicked()"
      />
    </div>
  }
  @if (showGameReplay()) {
    <div class="game-replay">
      <app-game-replay
        [gameId]="gameId()"
        [gameInterfaceState]="gameInterfaceState()"
        [reward]="reward()"
        [roomId]="roomId()"
        (closeClicked)="onCloseReplayClicked()"
      />
    </div>
  }
</div>
